@use '../../../../styles/scss/vcom/mixins/rtl';
@use '../../../../styles/scss/vcom/mixins/breakpoints';
@use '../../../../styles/scss/vcom/themes/classic/colors' as classic;

:root {
  --scrollbar-thumb-width: 50px;
}

vs-table {
  .vs-header-text-wrapper {
    width: calc(100% - 30px);
    max-width: 1140px;
    margin-left: auto;
    margin-right: auto;
  }

  .vs-table-wrapper {
    max-width: 1170px;
    overflow: hidden;
    overflow-x: scroll;
    -ms-overflow-style: none;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  table {
    width: 1140px;
    margin: 15px auto;
    overflow: visible;
    border-collapse: collapse;
    table-layout: fixed;
    border: solid 1px #{classic.$vs-tertiary-3};
    position: relative;

    @include breakpoints.desktop-plus-up {
      width: 100%;
      max-width: 1140px;
    }
  }

  thead {
    th[scope='col'] {
      text-align: center;
    }
  }

  th,
  td {
    font-weight: lighter;
    text-align: start;
    padding: 15px;
    border: 1px solid #dedede;

    &.vs-keyboard-focused {
      outline: 1px dashed black;
      outline-offset: 2px;
    }
  }

  td,
  th {
    >div:first-child {
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  th[scope='col'] {
    text-align: start;

    &[data-col-sortable='yes'] {
      cursor: pointer;
    }

    .vs-header-underline {
      text-decoration: underline;
    }

    .vs-table-sortable-icon {
      display: inline;
      vertical-align: middle;
      padding: 5px;
    }

    .vs-th-container {
      display: inline;
      justify-content: center;
    }
  }

  .vs-col-header {
    background-color: #eeeeee;
    color: #5c5c5c;
  }

  .vs-cell-white {
    background-color: white;
  }

  .vs-cell-grey {
    background-color: #{classic.$vs-tertiary-1};
  }

  tr {

    th:first-child,
    td:first-child {
      border-left-width: 0;

      @include rtl.rtl {
        border-left-width: 1px;
        border-right-width: 0;
      }
    }

    th:last-child,
    td:last-child {
      border-right-width: 0;

      @include rtl.rtl {
        border-right-width: 1px;
        border-left-width: 0;
      }
    }
  }

  .vs-table-legend-icon {
    &::before {
      font-size: 24px;
      margin-right: 5px;
      vertical-align: middle;

      @include rtl.rtl {
        margin-right: unset;
        margin-left: 5px;
      }
    }
  }

  .vs-table-icon {
    font-size: 24px;
  }

  .vs-legend-icon-desc {
    margin-right: 15px;

    @include rtl.rtl {
      margin-right: unset;
      margin-left: 15px;
    }
  }

  .vs-table-key-icon {
    margin-bottom: 15px;
    display: inline-block;

    @include breakpoints.mobile {
      display: block;
    }
  }

  .vs-table-cell-img {
    height: 112px;
    width: 200px;
  }

  .vs-table-scroll {
    -webkit-appearance: none;
    appearance: none;
    width: calc(100vw - 30px);
    height: 4px;
    background-color: #dedede;
    outline: none;
    opacity: 0.7;
    -webkit-transition: 0.2s;
    transition: opacity 0.2s;

    &::-webkit-slider-thumb {
      -webkit-appearance: none;
      appearance: none;
      width: var(--scrollbar-thumb-width, 50px);
      height: 4px;
      background: #808080;
      cursor: grab;
    }

    &::-moz-range-thumb {
      width: var(--scrollbar-thumb-width, 50px);
      height: 4px;
      background: #808080;
      cursor: grab;
    }

    &:active {
      &::-webkit-slider-thumb {
        background: #2c2c2c;
        outline: 1px dashed black;
        outline-offset: 2px;
      }

      &::-moz-range-thumb {
        background: #2c2c2c;
        outline: 1px dashed black;
        outline-offset: 2px;
      }
    }

    &:hover {
      &::-webkit-slider-thumb {
        background: #2c2c2c;
      }

      &::-moz-range-thumb {
        background: #2c2c2c;
      }
    }
  }
}

.table-printable {
  display: none;
}

@media print {
  .table-printable {
    height: 100%;
    display: block !important;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    margin: 0;
    font-size: 14px;
    line-height: 18px;
    overflow: visible !important;
    page-break-inside: avoid;

    vs-table {
      table {
        width: 100% !important;
        transform-origin: top left;
      }

      .vs-table-export-button,
      .vs-table-scroll {
        display: none !important;
      }

      .vs-header-text-wrapper {
        width: 98%;
      }

      .vs-table-wrapper {
        max-width: 100%;
        padding: 0;
      }

      th {
        tr {
          width: unset;
        }
      }
    }

    .vs-px-2 {
      padding: 0 !important;
    }
  }

  .vs-ignore-printing {
    display: none;
  }

  div,
  p,
  a,
  li,
  td,
  img {
    page-break-inside: avoid;
  }

  @page {
    size: A3;
    margin: 5px;
    orientation: auto;
  }
}
